import { FunctionComponent, useCallback, useRef } from 'react';
import useResizeObserver from 'use-resize-observer';
import { StyledTableRowDetails, TableRowDetailsContent } from './TableRowDetails.styled';
import { TableRowDetailsProps } from './types';

export const TableRowDetails: FunctionComponent<TableRowDetailsProps> = props => {
  const { children, onResize } = props;

  // Details container element reference
  const ref = useRef<HTMLDivElement>(null);

  // Observe details component height changes
  useResizeObserver({
    box: 'border-box',
    ref,
    onResize: useCallback(({ height }) => onResize(height as Optional<number>), [onResize]),
  });

  return (
    <StyledTableRowDetails ref={ref}>
      <TableRowDetailsContent>{children}</TableRowDetailsContent>
    </StyledTableRowDetails>
  );
};
